
import { Event }     from './event';
import { EventType } from './event.type';

/**
 *
 * @class NewPanoEvent
 *
 * when a new pano has been setup
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class NewPanoEvent extends Event {

  /** current kind of image (cube, sphere, etc.) */
  private _kind: string = '';

  /** current horizontal field of view */
  private _hfov: number = 0;

  /** current vertical field of view */
  private _vfov: number = 0;

  /** standard constructor */
  constructor(krpano : any, kind : string, hfov : number, vfov : number) {

    super(krpano, EventType.NEW_PANO);

    this._kind = kind;
    this._hfov = hfov;
    this._vfov = vfov;

  }

  /** fetch the kind of pano */
  kind(): string {

    return this._kind;
  }

  /** fetch the horizontal field of view */
  hfov(): number {

    return this._hfov;
  }

  /** fetch the vertical field of view */
  vfov(): number {

    return this._vfov;
  }
}
